import React, { useEffect, useState } from 'react';
const names = ['Monika Schneider', 'Hans-Peter Wagner', 'Ingrid Becker', 'Thomas Müller', 'Sabine Hoffmann', 'Dieter Fischer', 'Brigitte Weber', 'Klaus Richter', 'Petra Schäfer', 'Wolfgang Bauer'];
const cities = ['Berlin', 'München', 'Hamburg', 'Köln', 'Frankfurt', 'Stuttgart', 'Düsseldorf', 'Leipzig', 'Dresden', 'Bremen'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000); // Show for 4 seconds
    };
    // Initial delay before first popup
    const initialTimeout = setTimeout(showPopup, 5000);
    // Interval for subsequent popups (every 12-20 seconds)
    const interval = setInterval(() => {
      if (!isVisible) {
        setTimeout(showPopup, Math.random() * 8000 + 12000);
      }
    }, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <div className={`fixed top-4 right-4 z-50 bg-white border border-brand-sage/30 shadow-lg rounded-lg p-3 sm:p-4 max-w-[280px] sm:max-w-xs transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0 pointer-events-none'}`} data-id="element-156">
      <div className="flex items-start gap-3" data-id="element-157">
        <div className="bg-brand-sage-light p-2 rounded-full shrink-0" data-id="element-158">
          <svg className="w-4 h-4 text-brand-olive" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-159">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-160" />
          </svg>
        </div>
        <div data-id="element-161">
          <p className="text-xs sm:text-sm text-brand-text-main font-medium leading-tight" data-id="element-162">
            <span className="font-bold" data-id="element-163">{currentName}</span> aus {currentCity}{' '}
            hat gerade METABOLIK PRO gekauft.
          </p>
          <p className="text-[10px] sm:text-xs text-brand-text-muted mt-1" data-id="element-164">
            Vor wenigen Sekunden
          </p>
        </div>
      </div>
    </div>;
}